import { Country } from "country-state-city";

const UNITED_STATES = "United States";

export const COUNTRY_OPTIONS = Country.getAllCountries()
  .map((c) => ({ label: c.name, value: c.name }))
  .sort((a, b) => {
    if (a.label === UNITED_STATES) return -1;
    if (b.label === UNITED_STATES) return 1;
    return a.label.localeCompare(b.label);
  });

export const DESTINATION_FIRM_OPTIONS = ["NewEdge", "Summit", "Merchant", "Waverly"];

export const SOURCE_CUSTODIAN_OPTIONS = [
  "Fidelity IWS",
  "Fidelity NFS",
  "Schwab",
  "LPL Financial",
];

export const CUSTODIAN_OPTIONS = [
  "Fidelity",
  "Schwab",
  "Pershing",
  "Goldman Sachs",
  "Others",
];
